import { ColorInterface } from '@3ddv/ngx-sites-builder-lib';
import { Component, EventEmitter, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { SbApiService } from 'src/app/sites-builder/services/sb-api.service';
import { SblibService } from '../../../services/sblib.service';
import { ToolsService } from '../../services/tools.service';
import { CustomComponent } from '../custom/custom.component';
import { ColorInterfaceTemplate } from './models/colorinterfacetemplate.model';

@Component({
  selector: 'app-color-templates',
  templateUrl: './templates.component.html',
  styleUrls: ['./templates.component.scss'],
})
export class TemplatesComponent implements OnInit, OnDestroy {
  public subscriptions: Array<Subscription>;
  public templates: Array<ColorInterfaceTemplate>;
  public editMode: ColorInterfaceTemplate = null;
  @ViewChild('customtemplate') customTemplateChild: CustomComponent;
  @Output() appliedTemplate = new EventEmitter<ColorInterfaceTemplate>();
  @Output() updatedTemplatesList = new EventEmitter<Array<ColorInterfaceTemplate>>();

  constructor(
    private apiService: SbApiService,
    private route: ActivatedRoute,
    private toolsService: ToolsService,
    private sblibService: SblibService,
    private toastrService: ToastrService
  ) {
    this.subscriptions = [];
    this.templates = [];
  }

  ngOnInit(): void {
    this.templates = this.route.snapshot.data.dataFlow.workflow.template_colors;
    console.log(this.templates);
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(o => o.unsubscribe());
  }

  public editTemplate(template: ColorInterfaceTemplate) {
    this.editMode = JSON.parse(JSON.stringify(template));
  }

  public onDestroyTemplate() {
    const u$ = this.apiService.deleteTemplate(this.editMode.id).subscribe(res => {
      this.templates = this.templates.filter(i => {
        return i.id !== this.editMode.id;
      });
      this.editMode = null;
      this.updatedTemplatesList.emit(this.templates);
      this.toastrService.success('', 'Success');
    });
    this.subscriptions.push(u$);
  }

  public onUpdatedTemplate(template: ColorInterface) {
    this.templates = this.templates.map(i => {
      if (i.id === this.editMode.id) {
        i.name = this.editMode.name;
        i.values = Object.assign({}, template);
      }
      return i;
    });

    const body = {
      name: this.editMode.name,
      workflow_id: this.route.snapshot.data.dataFlow.workflow.id,
      values: JSON.stringify(template),
    };

    const u$ = this.apiService.updateTemplate(this.editMode.id, body).subscribe(res => {
      this.customTemplateChild.uploading = false;
      this.editMode = null;
      this.toastrService.success('', 'Success');
    });
    this.subscriptions.push(u$);
  }

  public applyTemplate(template: ColorInterfaceTemplate) {
    const tools$ = this.toolsService.getAsyncTools$().subscribe(res => {
      res.color.manual = JSON.parse(JSON.stringify(template.values));
      this.sblibService.apply(res);
      this.appliedTemplate.emit(template);
      this.toastrService.success('', 'Success');
    });
    this.subscriptions.push(tools$);
  }
}
